/*
 * PMS登录页
 */
import React from 'react';
import ReactDOM from 'react-dom';
import '@helpers/pms-bridge';
import Provider from '@store/Provider';
import { Router, Route } from 'x-react-router';
import loginReducer from '@reducers/pages/login';
import Login from '@containers/login';
// 全局
import Global from '@containers/global';
// Other pages
import { Home, FindPwd, Settings } from '@pages/.routers';
// initializer
import init from '@pages/.initializer';
import Loading from '@components/base/loading';

init(() => {
  ReactDOM.render(
    <Provider reducer={loginReducer}>
      <Router prefix="/pms">
        <Route path="/(home)?" component={Home} preload={true} />
        <Route path="/settings/*" component={Settings} preload={true} />
        <Route path="/login">
          <Login hasEpassErr={false} hasEpassErrWithCode={false} />
          <Global />
        </Route>
        <Route path="/findpwd" component={FindPwd} loading={Loading} />
      </Router>
    </Provider>,
    document.getElementById('pms')
  );
});



// WEBPACK FOOTER //
// ./pages/login.js